module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "package-info",
    on: {
      "click": function($event) {
        _vm.editModel(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.packageData.row.Package.Weight) + " g"), _c('br'), _vm._v(_vm._s(_vm.packageData.row.Package.Length) + "*" + _vm._s(_vm.packageData.row.Package.Width) + "*" + _vm._s(_vm.packageData.row.Package.Height) + "cm "), (!_vm.packageData.row.BlnSkuComplete) ? _c('span', {
    staticClass: "package-info-msg"
  }, [_vm._v("包裹规格需完善")]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.modelShow,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.modelShow = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "id": ("editformWeight" + _vm.DataID)
    },
    model: {
      value: (_vm.Weight),
      callback: function($$v) {
        _vm.Weight = $$v
      },
      expression: "Weight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', {
    staticClass: "pd-l-10"
  }, [_vm._v("单位g")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('label', [_vm._v("规格")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Length),
      callback: function($$v) {
        _vm.Length = $$v
      },
      expression: "Length"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Width),
      callback: function($$v) {
        _vm.Width = $$v
      },
      expression: "Width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Height),
      callback: function($$v) {
        _vm.Height = $$v
      },
      expression: "Height"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', {
    staticClass: "pd-l-10"
  }, [_vm._v("长宽高，单位cm")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editModel(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.packageSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3026bfd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/other/packageSize.vue
// module id = 833
// module chunks = 1